var exports = {
  "Q": "DependenciesPicker__urfcw4",
};

module.exports = exports;
